import React from 'react';

const LOCKUP_ASPECT = 1024 / 307;

export type BrandLogoProps = {
  variant?: 'brand' | 'icon' | 'lockup';
  className?: string;
  iconClassName?: string;
  textClassName?: string;
};

export function BrandLogo({
  variant = 'brand',
  className = '',
  iconClassName = 'h-8 w-8 rounded-lg',
  textClassName = 'font-bold tracking-tight text-primary-700 dark:text-primary-300',
}: BrandLogoProps) {
  if (variant === 'icon') {
    return (
      <img
        src="/logo.png"
        alt="Scoutlytics"
        className={className}
        width={32}
        height={32}
      />
    );
  }

  if (variant === 'lockup') {
    const width = 160;
    const height = Math.round(width / LOCKUP_ASPECT);
    return (
      <img
        src="/scoutlytics_website_logo_lockup.png"
        alt="Scoutlytics"
        className={className}
        width={width}
        height={height}
      />
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`.trim()} aria-label="Scoutlytics">
      <img
        src="/logo.png"
        alt=""
        aria-hidden="true"
        className={iconClassName}
        width={32}
        height={32}
      />
      <span className={textClassName}>Scoutlytics</span>
    </div>
  );
}

export default BrandLogo;
